import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import Navigation from '../../../components/Navigation/Navigation';
import { updateBirthdate } from '../../../actions/personalInfoAction';
import BirthdateFields from '../../../components/Fields/BirthdateFields';
import FormValidator from '../../../utils/FormValidator';
import { ValidateBirthdate } from '../../../utils/Validation';
import withBackgroundImage from '../../../HOC/withBackgroundImage';
import moment from 'moment';
import debounce from 'debounce';
import { format } from "date-fns";

class Birthdate extends Component {
  constructor(props) {
    super(props);    

    this.validator = new FormValidator([
      { 
        field: 'birthdate', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Oops, birthdate is required'
      },    
      { 
        field: 'birthdate', 
        method: ValidateBirthdate,
        validWhen: true, 
        message: 'Oops, this is not a valid date.'
      },
      { 
        field: 'birthdate', 
        method: 'isBefore',
        args: [moment().subtract(19, 'years').format()],
        validWhen: true, 
        message: 'Sorry, you must be at least 19 to apply for a Vancity credit card.'
      }      
    ]);    

    this.state = {
      birthdate: this.props.birthdate || "",
      validation: this.validator.valid()
    };

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  onClickForward(event) {
    event.preventDefault();
    this.setState({validation: this.validator.validate(this.state)}, () => {
      if(this.state.validation.isValid) {
        this.props.history.replace('/PersonalInfo/Contact');
      }
    });
  }
  onClickBackward() {
    this.props.history.replace('/PersonalInfo/Name');
  }
  handleChange(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.validateField(event.target.name, event.target.value)},
      [event.target.name]: format(new Date(event.target.value), "yyyy/MM/dd")
    }, () => {
      this.updateBirthdate();
    });
  }
  updateBirthdate = debounce(() => {
    this.props.updateBirthdate(this.state.birthdate);
  }, 1000);
  render() {
    return (
      <div>
        <h1>What’s your birthdate?</h1>
        <Form onSubmit={this.onClickForward}>
          <BirthdateFields handleChange={this.handleChange} {...this.state} />
          <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
        </Form>
      </div>);
  }
}

const mapStateToProps = state => ({
  ...state.personalInfo
});

const mapDispatchToProps = dispatch => ({
  updateBirthdate: (date) => dispatch(updateBirthdate(date))
});

export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("know-you")(Birthdate));


// WEBPACK FOOTER //
// ./src/containers/PersonalInfo/Birthdate/Birthdate.js